import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";

import FormModalidade from "./formModalidade";
import { IModalidade } from "interfaces/eventos";
import { modalHeaderSx, modalPaperSx } from "../modalidades.theme";

interface Props {
  open: boolean;
  onClose: () => void;
  modalidade: IModalidade | null;
}

export default function AddAndEditarModalidade({
  open,
  modalidade,
  onClose,
}: Props) {
  const isEdit = Boolean(modalidade);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{ sx: modalPaperSx }}
    >
      <Box sx={modalHeaderSx}>
        <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={2}>
          <Stack direction="row" spacing={2} alignItems="center" minWidth={0}>
            <CategoryOutlinedIcon sx={{ fontSize: 40, opacity: 0.9 }} />
            <Box minWidth={0}>
              <Typography variant="overline" sx={{ opacity: 0.75, letterSpacing: 1.2 }}>
                {isEdit ? "Editar modalidade" : "Nova modalidade"}
              </Typography>
              <Typography variant="h5" fontWeight="bold" noWrap>
                {isEdit ? modalidade?.tipo : "Tipo de modalidade"}
              </Typography>
              {isEdit ? (
                <Box mt={0.75}>
                  <Chip
                    size="small"
                    label="Cadastro ativo"
                    sx={{
                      bgcolor: "rgba(16, 185, 129, 0.9)",
                      color: "#fff",
                      fontWeight: 600,
                    }}
                  />
                </Box>
              ) : null}
            </Box>
          </Stack>
          <IconButton onClick={onClose} sx={{ color: "inherit" }} aria-label="Fechar">
            <CloseIcon />
          </IconButton>
        </Stack>
      </Box>

      <DialogContent sx={{ p: 0 }}>
        <FormModalidade modalidade={modalidade} onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
}
